import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const KEY = "maharlika_cart_v1";

const loadInitial = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (_) { return []; }
};

export function CartProvider({ children }) {
  const [items, setItems] = useState(loadInitial);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (it) => {
    setItems((prev) => {
      const key = `${it.item_type}:${it.item_id}:${JSON.stringify(it.options || {})}`;
      const idx = prev.findIndex((p) => `${p.item_type}:${p.item_id}:${JSON.stringify(p.options || {})}` === key);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + (it.quantity || 1) };
        return copy;
      }
      return [...prev, { quantity: 1, options: {}, addons: [], notes: "", ...it }];
    });
  };

  const updateQty = (idx, qty) => {
    setItems((prev) => prev.map((p, i) => i === idx ? { ...p, quantity: Math.max(1, qty) } : p));
  };

  const removeItem = (idx) => setItems((prev) => prev.filter((_, i) => i !== idx));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, it) => s + it.unit_price * it.quantity, 0);
  const count = items.reduce((s, it) => s + it.quantity, 0);
  const hasRestaurant = items.some((i) => ["restaurant","catering","lechon"].includes(i.item_type));
  const hasGrocery = items.some((i) => i.item_type === "grocery");

  return (
    <CartCtx.Provider value={{ items, addItem, updateQty, removeItem, clear, subtotal, count, hasRestaurant, hasGrocery }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
